import {OrdRaceStatusEnum} from "./enums/ordRaceStatusEnum";

/**
 * WebSocket message event types
 */
export enum WebSocketEventType {
  RACE_DATA = 'RACE_DATA',
  HEARTBEAT = 'heartbeat',
  INFO = 'info',
  ERROR = 'error',
}

/**
 * Consolidated race and leaderboard status for UI
 */
export interface RegattaRaceResultStatus {
  raceToTheFinal: RacePointsPerTeam[];
  fleetRaceResults: FleetRaceResults[];
}

/**
 * Team points in a race or overall standings
 */
export interface RacePointsPerTeam {
  country: string;
  points: number;
  penaltyPoints?: number;
}

/**
 * Fleet race results with winners
 */
export interface FleetRaceResults {
  name: string;
  start: string;
  end: string;
  status: OrdRaceStatusEnum;
  winners: RacePointsPerTeam[];
}
